export default "__VITE_ASSET__DDfbRK6k__"